<div class="row mt-3" *ngIf="!globals.isPaymentDetails">
  <div class="col-auto">
    <button type="button" class="btn btn-square bg-dark" style="color: #ffffff" title="Click to go back"
      *ngIf="globals.isPaymentHistory" (click)="GetBack()">
      <i class="fa fa-lg fa-arrow-left" aria-hidden="true"></i> Back
    </button>
  </div>
  <div class="col-lg fontsizeandfamilyCalibri">
    <div class="grid-b-space">
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblGuestName">Guest Name</label><!--Guest Name-->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{GuestHistory[0].GuestName}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblExpectedcheckin">Date of birth</label> <!--Expected check-in-->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{GuestHistory[0].DateOfBirth}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-right mt-2">
          <label id="lblExpectedcheckout">Age</label><!--Expected check-out-->
        </div>
        <div class="col-md-5 text-left mt-2">
          <strong>{{GuestHistory[0].Age}}</strong>
        </div>
      </div>

    </div>
  </div>
  <div class="col-lg fontsizeandfamilyCalibri">
    <div class="row">
      <div class="col-md-3 text-right mt-2">
        <label id="lblNoofdays">Sex</label><!----No. of days---->
      </div>
      <div class="col-md-5 text-left mt-2">
        <strong>{{GuestHistory[0].Gender}}</strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right mt-2">
        <label id="lblAccomodation">Address</label><!--Accomodation-->
      </div>
      <div class="col-md-5 text-left mt-2">
        <strong>{{GuestHistory[0].Address}}</strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right mt-2">
        <label id="lblEmail">E-mail</label><!--E-mail-->
      </div>
      <div class="col-md-5 text-left mt-2">
        <strong>{{GuestHistory[0]['Email']}}</strong>
      </div>
    </div>

  </div>
</div>

<div class="row mt-4 justify-content-center" *ngIf="!globals.isPaymentDetails">
  <div class="table-responsive fontsizeandfamilyCalibri">
    <div class="unseen">
      <table class="table table-striped table-hover  text-left " data-page-size="15" data-filtering="true"
        data-sorting="true">
        <thead>
          <tr style="background-color: #77c5ec;">
            <th style="min-width: 20px !important; max-width: 20px !important;">No.</th>
            <th>Payment Date </th>
            <th>Amount</th>
            <th>Carry Forward Amount</th>
            <th>Total Balance Amount</th>
            <th>Type</th>
            <th>Product Info</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Service Provider</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr style="background-color: #e3ebdc;"
            *ngFor="let item of PaymentHistory | filter : filters | paginate: { itemsPerPage: 10, currentPage: page };  let i = index">
            <td style="min-width: 20px !important; max-width: 20px !important;">
              {{ 10 * (page - 1) + i + 1}}
            </td>

            <td>{{item.PaymentDate | date:"dd-MM-yyyy"}}</td>
            <td>{{item.AdvBookingAmt}}</td>
            <td>{{item.CarryForwardAmount}}</td>
            <td>{{item.BalanceAmount}}</td>
            <td>{{item.Type}}</td>
            <td>{{item.ProductInfo}}</td>
            <td>{{GuestHistory[0]['Email']}}</td>
            <td>{{item.MobileNo}}</td>
            <td>Razorpay</td>
            <td>{{item.PaymentStatus}}</td>
            <td><i class="fa fa-edit mr-1"
                (click)="GetPaymentAndOrderDetails(item.PaymentID,item.ThirdpartyPaymentID,item.ThirdpartyPaymentOrderID);"
                title="Payment Details"></i></td>

        </tbody>
      </table>
    </div>
    <pagination-controls (pageChange)="page = $event" [maxSize]="10" [directionLinks]="true" [autoHide]="true"
      [responsive]="true">
    </pagination-controls> <!----- Page No ------>
  </div>
</div>



<app-payment-details *ngIf="globals.isPaymentDetails" [paymentDetails]="paymentDetails" [orderDetails]="orderDetails"
  [customDetails]="customDetails"></app-payment-details>